import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import IntroduceBtn from '@atoms/btn/IntroduceBtn';
import { useTranslation } from 'react-i18next';

const BoardHeader = ({ type }) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const isLink = location.pathname.includes('link');
  const handleCategory = type => {
    navigate(`/${i18n.language}${isLink ? '/link' : ''}/community/${type}`);
  };
  return (
    <>
      <div className="mt-[20px] md:mt-[120px] flex mb-[25px] sm:mb-[50px] items-center">
        <ul className="notice_navi text-center text-sm sm:text-md w-[60%] md:w-[70%] m-auto ">
          <li className="grid grid-cols-2 relative gap-[6px] text-md">
            <IntroduceBtn
              text={'공지사항'}
              isActive={type === 'news' ? true : false}
              addClass="!py-4 "
              onClick={() => handleCategory('news')}
            />
            <IntroduceBtn
              text={'이벤트'}
              isActive={type === 'event' ? true : false}
              addClass="!py-4 "
              onClick={() => handleCategory('event')}
            />
          </li>
        </ul>

        <a
          href={t('GUIDE_LINK')}
          target="_blank"
          className="  ml-2 line-block sm:m-auto font-nuniSans text-[#a68df7] flex items-center text-xs  md:text-md  sm:py-3 py-3 md:py-4 px-5  md:px-10 rounded-full font-bold btn-coupon-style2 text-center"
        >
          {t('인더섬 가이드')}
        </a>
      </div>
    </>
  );
};

export default BoardHeader;
